import id from './batch';
import query from './unsubscribe';
import get from './get';
import post from './post';
import put from './put';

export default { id, query, get, post, put };
